export const codes = [
    "fr",
    "en"
];